module.exports = __webpack_public_path__ + "img/defaultMark-light01.9967eb82.png";